function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWrapper, LabelTypography, RadioButton, Wrapper } from './styles';
export var optionsPropType = PropTypes.arrayOf( // TODO make this more sophisticated and based on keyBy and labelBy props
PropTypes.shape({
  label: PropTypes.string,
  key: PropTypes.string
})).isRequired;
export var propTypes = {
  onChange: PropTypes.func.isRequired,
  isOptionDisabled: PropTypes.func,
  options: optionsPropType,
  value: PropTypes.string,
  keyBy: PropTypes.string,
  labelBy: PropTypes.string
};
export var RadioButtonGroup = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(RadioButtonGroup, _React$PureComponent);

  var _super = _createSuper(RadioButtonGroup);

  function RadioButtonGroup() {
    var _this;

    _classCallCheck(this, RadioButtonGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (key) {
      return function () {
        var _this$props = _this.props,
            onChange = _this$props.onChange,
            name = _this$props.name;
        onChange({
          target: {
            value: key,
            name: name
          }
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "getOptionKey", function (option) {
      var keyBy = _this.props.keyBy;
      return option[keyBy];
    });

    _defineProperty(_assertThisInitialized(_this), "getOptionLabel", function (option) {
      var labelBy = _this.props.labelBy;
      return option[labelBy];
    });

    _defineProperty(_assertThisInitialized(_this), "renderOption", function (option) {
      var _this$props2 = _this.props,
          value = _this$props2.value,
          isOptionDisabled = _this$props2.isOptionDisabled;

      var key = _this.getOptionKey(option);

      var label = _this.getOptionLabel(option);

      return /*#__PURE__*/React.createElement(ButtonWrapper, {
        key: key
      }, /*#__PURE__*/React.createElement(RadioButton, {
        color: "primary",
        variant: key === value ? 'contained' : 'outlined',
        disabled: isOptionDisabled(option),
        onClick: _this.handleClick(key)
      }, /*#__PURE__*/React.createElement(LabelTypography, {
        color: "inherit"
      }, label)));
    });

    return _this;
  }

  _createClass(RadioButtonGroup, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          onChange = _this$props3.onChange,
          options = _this$props3.options,
          value = _this$props3.value,
          rest = _objectWithoutProperties(_this$props3, ["onChange", "options", "value"]);

      return /*#__PURE__*/React.createElement(Wrapper, rest, options.map(this.renderOption));
    }
  }]);

  return RadioButtonGroup;
}(React.PureComponent);

_defineProperty(RadioButtonGroup, "propTypes", propTypes);

_defineProperty(RadioButtonGroup, "defaultProps", {
  keyBy: 'key',
  labelBy: 'label',
  isOptionDisabled: function isOptionDisabled() {
    return false;
  }
});

export default RadioButtonGroup;